import { Injectable } from '@angular/core';
import { CommonConstants } from '@coreConstant';
import { GoogleAddressModel, PaginationModel } from '@coreModels';
import { ToastService } from './toast.service';

@Injectable({
  providedIn: 'root',
})
export class UtilityService {
  constructor(private toastService: ToastService) {}

  /**
   * Common Function for displaying error image
   * @param event
   * @param image
   */
  public getErrorImage(event: any, image?: any) {
    image == '' || image == undefined
      ? (event.target.src = CommonConstants.NO_IMAGE_PRODUCT)
      : (event.target.src =
          CommonConstants.IMAGE_KIT_ENDPOINT +
          '/ASSETS/GENERAL/IMAGES/' +
          image);
  }

  /**
   * Common Function for the Google Address
   * @param address
   */
  public addressHandler(address: any) {
    let isStreet = false;
    let addressModel = new GoogleAddressModel();
    if (address !== undefined && address.formatted_address !== undefined) {
      let streetAddress = '';
      address.address_components.map((component: any) => {
        const componentType = component.types[0];
        switch (componentType) {
          case 'subpremise': {
            streetAddress = streetAddress + component.long_name + '/';
            break;
          }
          case 'street_number': {
            isStreet = true;
            streetAddress = streetAddress + component.long_name;
            break;
          }
          case 'premise': {
            streetAddress =
              streetAddress + (streetAddress != '' ? ',' : '') + ' ';
            break;
          }
          case 'route': {
            let addressRoute = component.long_name;
            if (streetAddress != '') {
              addressRoute = streetAddress + ', ' + component.long_name;
            }
            addressModel.address_line_1 = addressRoute;
            break;
          }
          case 'sublocality_level_3': {
            addressModel.address_line_2 = component.long_name;
            break;
          }
          case 'postal_code': {
            addressModel.post_code = component.long_name;
            break;
          }
          case 'locality': {
            addressModel.suburb = component.long_name;
            break;
          }
          case 'administrative_area_level_1': {
            addressModel.state_region = component.short_name;
            break;
          }
          case 'administrative_area_level_2': {
            addressModel.town_city = component.long_name;
            break;
          }
          case 'country': {
            addressModel.country = component.long_name;
            break;
          }
        }
        return true;
      });
      addressModel.isStreetAddress = isStreet;
      addressModel.lattitude = address.geometry.location.lat();
      addressModel.longitude = address.geometry.location.lng();
      return addressModel;
    }

    return;
  }

  /**
   * @description Common function for the get(listing) request
   * @param response
   */
  public processPaginationResponse<T>(response: any): PaginationModel<T> {
    const paginationModel = new PaginationModel<T>();
    const headers = response.headers;
    paginationModel.setHeaders(headers);
    paginationModel.data = response.body.data as T[]; // Use the generic type for the data
    return paginationModel;
  }

  /**
   * Creates a slug from the given string.
   * @param slug The input string to convert into a slug.
   * @returns A slugified string.
   */
  public createSlug(slug: string): string {
    // Regular expression to match allowed characters
    const lettersOnlyPattern = /[^\-\s\p{L}]+/gu; // Remove all characters except letters, hyphen, and spaces
    const spacesDuplicateUnderscorePattern = /[\-\s]+/g; // Remove duplicate dashes (-) and spaces

    // Use the appropriate pattern based on the isAllowNumber flag
    const pattern = lettersOnlyPattern;

    // Convert to lowercase, remove unwanted characters
    slug = slug.toLowerCase().replace(pattern, '');

    // Replace spaces or multiple dashes with a single dash
    slug = slug.replace(spacesDuplicateUnderscorePattern, '-');

    // Trim any leading or trailing dashes
    slug = slug.replace(/^-+|-+$/g, '');

    return slug;
  }

  /**
   * Common Function to get file name
   * @param str
   * @returns filename
   */
  getFileName(str: any, usefor = 'alt') {
    let fileName = '';
    if (str != undefined && str !== null && str !== '') {
      let newFileName = str.split('\\').pop().split('/').pop(); // Get file name
      newFileName = newFileName.split('/').slice(-1).join().split('.').shift(); // Remove extension
      fileName = newFileName.replace(/_/g, ' '); // Replace underscore(_) with dash(-)
    }
    if (usefor == 'title') {
      fileName = fileName.toUpperCase();
    }
    return fileName;
  }

  copyText(str: string, successMessage: string) {
    const decodedText = decodeURIComponent(str);
    if (navigator.clipboard && navigator.clipboard.writeText) {
      // Use Clipboard API if supported
      navigator.clipboard
        .writeText(decodedText)
        .then(() => {
          this.toastService.showSuccess(successMessage);
        })
        .catch((err) => {
          this.toastService.showError(
            'Failed to copy the link. Please try again.'
          );
        });
    } else {
      // Fallback for unsupported browsers
      try {
        const listener = (e: ClipboardEvent) => {
          e.clipboardData?.setData('text/plain', decodedText);
          e.preventDefault();
        };
        document.addEventListener('copy', listener);
        const successful = document.execCommand('copy');
        document.removeEventListener('copy', listener);

        if (successful) {
          this.toastService.showSuccess(successMessage);
        } else {
          this.toastService.showError(
            'Failed to copy the link. Please try again.'
          );
        }
      } catch (err) {
        this.toastService.showError(
          'Copy operation failed. Please try manually.'
        );
      }
    }
  }
}
